import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ValidationErrorModule } from '@lib/components';
import { ThrottleClickDirectiveModule } from '@lib/directives';
import { StaticMsgModule } from '@lib/pipes';
import { RadiobuttonBoxCarouselComponent } from './radiobutton-box-carousel.component';

@NgModule({
  declarations: [RadiobuttonBoxCarouselComponent],
  imports: [CommonModule, ValidationErrorModule, ThrottleClickDirectiveModule, StaticMsgModule],
  exports: [RadiobuttonBoxCarouselComponent],
})
export class RadiobuttonBoxCarouselModule {}
